// import PreviewStylesCss from "../../../styles/PreviewStyles.css";


export const styles = (theme) => ({
  // ...PreviewStylesCss,
 
 

  
});
